import { render } from "./Dash.vue?vue&type=template&id=7b513ae0&scoped=true"
import script from "./Dash.vue?vue&type=script&lang=js"
export * from "./Dash.vue?vue&type=script&lang=js"

import "./custom-dash.scss?vue&type=style&index=0&id=7b513ae0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b513ae0"]])

export default __exports__